import React, { useState, useEffect } from "react";
import "./SettingsSide.css";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import LogoutPopup from "../SettingPages/LogoutPopup";
import { useNavigate } from "react-router-dom";
import { handleNewConversationRequest } from "../../../../store/one-query/chatsSlice";
import useNavigateToMainPage from "../../../../NavigateToMainPage";
import EmailIcon from "../../../../Custom-imeges/EmailIcon";
import PasswordIcon from "../../../../Custom-imeges/PasswordIcon";
import EditPinIcon from "../../../../Custom-imeges/EditPinIcon";
import PopupEditName from "./PopupEditName";
import HelpAndSupportIcon from "../../../../Custom-imeges/HelpAndSupportIcon";
import ContactUsIcon from "../../../../Custom-imeges/ContactUsIcon";
import PrivacyAndPolicyIcon from "../../../../Custom-imeges/PrivacyAndPolicyIcon";
import TermAndConditionIcon from "../../../../Custom-imeges/TermAndConditionIcon";
import FullNameIcon from "../../../../Custom-imeges/FullNameIcon";
import ArchieveIcon from "../../../../Custom-imeges/ArchieveIcon";

import { useGetConversationTypes } from "../../../../store/Apis/ConversationTypeApi";
import ArchievedPersonas from "./Persona/ArchievedPersonas";
import { Box } from "@mui/material";
interface ChangeSideDisplay {
  setToDarkMode: () => void;
  setToLightMode: () => void;
}
function SettingsSide({ setToDarkMode, setToLightMode }: ChangeSideDisplay) {
  const navigate = useNavigate();
  const dispatch=useAppDispatch();
  const navigateToMainPage = useNavigateToMainPage();
  const getAllPersonas=useGetConversationTypes()
  const switchToMainSide = () => {
    navigateToMainPage();
  };
  let darkMode = useAppSelector((state) => state.User.darkMode);
  const userData=useAppSelector((s)=>s.User.userData)
  const [toggleState, setToggleState] = useState(darkMode);
  const [isHoverFullName, setIsHoverFullName]=useState<boolean>(false);
  const [isOpenToEditName, setIsOpenToEditName] = useState<boolean>(false);
  const [isOpenArchivedPersonas, setIsOpenArchivedPersonas] =
  useState<boolean>(false);
  useEffect(() => {
    if (toggleState) {
      setToDarkMode();
    } else {
      setToLightMode();
    }
  }, [toggleState]);
  useEffect(()=>{
    getAllPersonas();
  },[])
  const [active, setActive] = useState("None");
  return (
    <>
      <div className="settingsMain">
           <div className="settingsHeader">
            <div className="d-flex">
              <img
                className="arrowIconImg"
                src="/Images/SettingsSideResources/icn-arrow-left.svg"
                onClick={() => switchToMainSide()}
              />
              <p className="settingsHeaderTitle">Settings</p>
            </div>
          </div>
        <div className="settingsMainOffset">
          <div className="line lineSpeartor-settings" style={{margin:"0 0 12px 0"}}></div>
          <div  style={{
            padding:"0 16px",
            overflow:"hidden",
            height:"100%",
          }}>
          <div className="settingsBody">
            {/* Personal information section  */}
            <div>

            <div className="personal-information-section">
              <p className="section-title">Personal information</p>
              <p className="section-description">
                Update your personal information and secure your account
              </p>
              <div style={{
                display:"flex",
                flexDirection:"column",
                gap:"8px"
              }}>
                <div className="subSectionEmail-style">
                    <EmailIcon className="custom-icon" />
                  <p className="section-subTitle">Email</p>
                  <span className="content-style ms-5 ps-4">
                    {userData?.email}
                  </span>
                </div>

                <div
                  className=" subSection-style"
                  onMouseOver={() => setIsHoverFullName(true)}
                  onMouseLeave={() => setIsHoverFullName(false)}
                  onClick={() => setIsOpenToEditName(true)}
                >
                    <FullNameIcon className="custom-icon" />
                  <p className="section-subTitle">Full name</p>
                  <span className="content-style ms-5">
                    {userData?.firstName + " " + userData?.lastName}
                  </span>
                  {isHoverFullName && (
                      <EditPinIcon
                        className="custom-icon"
                        source="SettingPage"
                      />
                   )} 
                </div>

                <div
                  className=" subSection-style"
                  onClick={() => {
                    navigate("/change-password");
                  }}
                >
                    <PasswordIcon className="custom-icon" />
                  <p className="section-subTitle">Password</p>
                </div>
              </div>
            </div>

            <div className="line-speartor-settings"></div>
              {/* Archived Persona section */}
            <div className="Support-section">
              <p className="section-title">Persona</p>
              <p className="section-description">Manage your personas</p>
                <div
                  className="subSection-style"
                  onClick={() => setIsOpenArchivedPersonas(true)}
                >
                    <ArchieveIcon className="custom-icon" />
                  <p className="section-subTitle">Archived personas</p>
              </div>
            </div>

            <div className="line-speartor-settings"></div>

            {/* Support section */}
            <div className="Support-section">
              <p className="section-title">Support</p>
              <p className="section-description">
                For questions or to reach our team
              </p>
              <div style={{
                display:"flex",
                flexDirection:"column",
                gap:"8px"
              }}>
                <div
                  className="subSection-style"
                  onClick={() => {
                    navigate("/help-and-support");
                  }}
                >
                    <HelpAndSupportIcon className="custom-icon" />
                  <p className="section-subTitle">Help & support</p>
                </div>
                <div
                  className=" subSection-style"
                  onClick={() => {
                    navigate("/contact-us");
                  }}
                >
                    <ContactUsIcon className="custom-icon" />
                  <p className="section-subTitle">Contact Us</p>
                </div>
              </div>
            </div>

            <div className="line-speartor-settings"></div>

            {/*Legal section  */}
            <div className="Support-section">
              <p className="section-title">Legal</p>
              <p className="section-description">
                Learn more about your rights and responsibilities
              </p>
              <div style={{
                display:"flex",
                flexDirection:"column",
                gap:"8px"
              }}>
                <div
                  className="d-flex subSection-style"
                  onClick={() => navigate("/privacy-policy")}
                >
                    <PrivacyAndPolicyIcon className="custom-icon" />
                  <p className="section-subTitle">Privacy & policy</p>
                </div>

                <div
                  className="d-flex  subSection-style"
                  onClick={() => navigate("/term-condition")}
                >
                    <TermAndConditionIcon className="custom-icon" />
                  <p className="section-subTitle">Terms & conditions</p>
                </div>
              </div>
            </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      {active === "Logout" && <LogoutPopup />}
      {isOpenToEditName && (
        <PopupEditName
          show={isOpenToEditName}
          handleClosePopUp={() => setIsOpenToEditName(false)}
        />
      )}
       {isOpenArchivedPersonas && (
        <ArchievedPersonas
          show={isOpenArchivedPersonas}
          handleClose={()=>setIsOpenArchivedPersonas(false)}
        />
      )}
    </>
  );
}
export default SettingsSide;
